<template>
  <div>
  <b-navbar toggleable="lg" type="dark" variant="dark" fixed="top" :class="{ 'hidden-navbar': !showNavbar }">
    <b-navbar-brand v-scroll-to="'#app'" href="#" :class="{ 'sm-brand': !showNavbar }"><img src="img/logo.png" class="brand_img" alt=""><!-- <img src="img/Header-2.jpg" class="sub_brand" alt=""> --></b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
     <!--  <b-navbar-nav>
        <b-nav-item href="#" disabled><img src="img/Header-2.jpg" width="120px;" alt=""></b-nav-item>
      </b-navbar-nav> -->

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-navbar-nav right>
          <b-nav-item v-scroll-to="'#location'">LOCATION</b-nav-item>
          <b-nav-item v-scroll-to="'#landmark'">LANDMARK</b-nav-item>
          <b-nav-item v-scroll-to="'#engineering'">ENGINEERING</b-nav-item>
          <b-nav-item v-if="mobile" v-scroll-to="'#suite'" class="suite-nav">SUITES</b-nav-item>
          <b-nav-item v-else @mouseover="onOver" @mouseleave="onLeave" v-scroll-to="'#suite'" class="suite-nav">SUITES</b-nav-item>
         
          <div @mouseover="onOver" @mouseleave="onLeave">
          <b-nav-item-dropdown text="" ref="dropdown" right>
            <b-dropdown-item v-scroll-to="'#suite'">PHOTO GALLERY</b-dropdown-item>
            <!-- <b-dropdown-item v-scroll-to="'#virtual_tour'">VIDEO TOUR</b-dropdown-item> -->
            <b-dropdown-item v-scroll-to="'#view'">VIEW</b-dropdown-item>
           <!--  <b-dropdown-item v-scroll-to="'#garage'">GARAGE</b-dropdown-item> -->
            <b-dropdown-item v-scroll-to="'#floor_plan'">FLOOR PLAN</b-dropdown-item>
    <!--         <b-dropdown-item v-scroll-to="'#elevation'">ELEVATION</b-dropdown-item>
            <b-dropdown-item v-scroll-to="'#furniture'">FURNITURE</b-dropdown-item> -->
          </b-nav-item-dropdown>
          </div>
          <b-nav-item v-scroll-to="'#contact'">INQUIRIES</b-nav-item>
        </b-navbar-nav>

      </b-navbar-nav>
    </b-collapse>
  </b-navbar>

</div>

</template>

<script>
export default {
  data(){
    return {
      mobile: false,
      show:true,
    }
  },
  name: 'NavBar',
  methods: {

      onOver() {
        this.$refs.dropdown.visible = true;
      },
      onLeave() {
        this.$refs.dropdown.visible = false;
      },
      onResize() {
      if (window.innerWidth < 500) {
          this.mobile = true;
      } else {
          this.mobile = false;
        }
      },
  },
  mounted(){

    if(window.innerWidth < 500){
       this.mobile = true;
       console.log('mobile');
    }else{
       this.mobile = false;
    }
  },
  created() {
    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);

  },



  }

</script>
<style>
  .navbar, .navbar-brand, .navbar-nav{
    transition: 0.4s all ease-out;
  }
  .navbar.hidden-navbar {
    box-shadow: none;
    padding-top: .7% !important;
    padding-bottom: .7% !important;
    /*transform: translate3d(0, -20px, 0);*/
  }
  .sm-brand{
    transform: scale(0.88, 0.88);
  }
  ul.dropdown-menu{
    padding: 1rem 0.5rem;
    top: 90%;
  }
  .dropdown-item:hover, .dropdown-item:focus {
    background-color: #c5c6c8 !important;
  }
  @media (min-width: 992px){
    .suite-nav a{
    padding-right: 0 !important;
  }
    .dropdown-toggle{
      padding-left: 0 !important;
    }
    .dropdown-toggle:focus{
      outline:none;
    }
  }
  @media (max-width: 992px){
      .b-nav-dropdown .nav-link{
        position: absolute;
        top: -39px;
        left: 53%;
      }
    }
  @media (max-width: 800px){
      .b-nav-dropdown .nav-link{
        position: absolute;
        left: 54%;
      }
  }  
  @media (max-width: 620px){
      .b-nav-dropdown .nav-link{
        position: absolute;
        left: 55%;
      }
  } 
  @media (max-width: 500px){
      .b-nav-dropdown .nav-link{
        position: absolute;
        left: 56%;
        padding: 10px 20px 10px 0 !important;
      }
      .dropdown-toggle::after{
        margin-left: 0.65em !important;
        border-top: 0.5em solid !important;
        border-right: 0.5em solid transparent !important;
        border-left: 0.5em solid transparent !important;
      }
  }
  @media (max-width: 350px){
      .b-nav-dropdown .nav-link{
        position: absolute;
        left: 57%;
      }
  }
  


</style>
<style scoped>
   .brand_img{
     width: 200px;
   }
   .sub_brand{
     width: 120px;
     margin: 40px 0 0 20px;
   }
   .navbar-dark{
      background-color:black!important;
      padding: 1.5% 3% 1.5% 3%;
    }
    .navbar-brand{
       font-size: 60px;
       line-height: 50px;
       color: #bfbfbf !important;
       text-align: left;
    }
    .navbar-expand-lg .navbar-collapse {
        align-self: flex-end;
    }
    @media (max-width: 992px){
      .brand_img{
         width: 170px;
       }
       .sub_brand{
         width: 100px;
         margin: 40px 0 0 20px;
       }
    }
    @media (max-width: 768px){
      .navbar-dark{
      padding: 2.5% 3% 2.5% 3%;
      }
      .brand_img{
         width: 150px;
       }
       .sub_brand{
         width: 90px;
         margin: 35px 0 0 20px;
       }
    }
    @media (max-width: 414px){
      .navbar-dark{
      padding: 4% 3% 4% 3%;
      }
      .brand_img{
         width: 120px;
       }
       .sub_brand{
         width: 72px;
         margin: 25px 0 0 10px;
       }
    }
</style>
